
import { router } from '@/helpers/router';
import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';

/**
 * Renders the current screen title in the header (mobile version)
 */
class HeaderTitleMobile extends Component {
  state = {
    currentTitle: '',
  };

  componentDidMount() {
    this.updateTitle();
    // Listen for hash changes to update title when navigating
    window.addEventListener('hashchange', this.updateTitle);
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.updateTitle);
  }

  updateTitle = () => {
    const currentPath = this.getCurrentPath();
    const currentRoute = router.find(route => route.url === currentPath);
    
    if (currentRoute) {
      this.setState({ currentTitle: currentRoute.text });
    } else {
      this.setState({ currentTitle: '' });
    }
  };

  getCurrentPath = () => {
    // Get current path from hash, e.g., "#/people-counts?..." -> "/people-counts"
    const hash = window.location.hash;
    if (!hash) return '';
    
    const path = hash.split('?')[0].substring(1); // Remove # and everything after ?
    return path;
  };

  render() {
    const { currentTitle } = this.state;

    if (!isMobile || !currentTitle) {
      return <></>;
    }
    
   

    return (
      <div className="header-title">
        <div className="screen-name">
          {currentTitle}
        </div>
      </div>
    );
  }
}

export default HeaderTitleMobile; 
